
import { createContext, useContext } from "react"

export const ModalContext = createContext({});

export function useModalContext() {
  return useContext(ModalContext);
}

